// extracted by css-extract-rspack-plugin
export default {"overlayContainer":"CGQt6DHo"};